import DrawOutcomeCard from './component';

export default DrawOutcomeCard;
